<template>
  <el-dialog
  :visible.sync="visible"
  title="饮食解读"
  fullscreen
  :before-close="handleClose"
  >
   <dietInterpret :doctorId="doctorId" :hideTitle="true" :readOnly="true"/>
  </el-dialog>
</template>
<script>
import dietInterpret from "../dietInterpret.vue";
export default {
  props: ["visible","doctorId"],
  components: {
    dietInterpret
  },
  data() {
    return {


    };
  },
  mounted(){


  },
  created() {

  },
  methods: {
    handleClose: function () {
      this.$emit('close');
    }
  },
};
</script>
<style lang="less" scoped="scoped">

</style>
